import { render, staticRenderFns } from "./CircleActionIcon.vue?vue&type=template&id=45a40014&scoped=true&"
import script from "./CircleActionIcon.vue?vue&type=script&lang=js&"
export * from "./CircleActionIcon.vue?vue&type=script&lang=js&"
import style0 from "./CircleActionIcon.vue?vue&type=style&index=0&id=45a40014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a40014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
